import { Fragment } from "react";
import {
  FilteringForm,
  initialFilteringValues,
  filteringValidationSchema,
} from "./FilteringForm";
import { PageHeader } from "../../../components/PageHeader";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import OpenInBrowserOutlinedIcon from "@material-ui/icons/OpenInBrowserOutlined";
import Button from "@material-ui/core/Button";
import { Formik } from "formik";

export const ListingPageHeader = (props) => {
  const { setCreating, handleFilterChange, clearNotification, onExport } = props;

  return (
    <PageHeader title="訂金記錄">
      <Formik
        initialValues={initialFilteringValues}
        validationSchema={filteringValidationSchema}
      >
        {() => (
          <Fragment>
            <FilteringForm handleFilterChange={handleFilterChange} />
            <Button
              style={{ marginRight: 15, marginBottom: 15 }}
              variant="contained"
              color="primary"
              startIcon={<AddCircleOutlinedIcon />}
              onClick={() => {
                clearNotification();
                setCreating(true);
              }}
            >
              新增訂金
            </Button>
            <Button
              style={{ marginRight: 15, marginBottom: 15 }}
              variant="contained"
              color="primary"
              startIcon={<OpenInBrowserOutlinedIcon />}
              onClick={onExport}
            >
              匯出
            </Button>
          </Fragment>
        )}
      </Formik>
    </PageHeader>
  );
};
